import {CodeEmail} from "@/models/auth";
import {apiConfig} from "@/store";

export const postCodeEmail = (data: CodeEmail) => apiConfig.request(
    {
        endpoint: apiConfig.endpoints?.postCodeEmail,
        data: data,
        isSetSession: true
    }
);

export const renewCodeEmail = () => apiConfig.request({
    endpoint: apiConfig.endpoints?.renewCodeEmail
});
